import React, { useState, useEffect } from 'react';
import { actualizarTurno, obtenerTurnoPorId, obtenerVigilantePorCodigoPersona, agregarTurno, parseRequierePersonas } from '../data/FirestoreCuadrantes';
import { Button, Box, Grid, Typography, FormGroup, FormControlLabel, Checkbox, CircularProgress, Alert } from '@mui/material';
import './CreateTramo.css';

const ActualizarTurno = ({ cuadranteId, turnoId, currentService, onUpdateComplete, servicioId, onClose }) => {
  const [inicioTurno, setInicioTurno] = useState('');
  const [finTurno, setFinTurno] = useState('');
  const [arcos, setArcos] = useState(false);
  const [manejoExplosivos, setManejoExplosivos] = useState(false);
  const [peligrosidad, setPeligrosidad] = useState(false);
  const [conArma, setConArma] = useState(false);
  const [observaciones, setObservaciones] = useState('');
  const [fechaSeleccionada, setFechaSeleccionada] = useState('');
  const [turnoAsignado, setTurnoAsignado] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [exito, setExito] = useState(false);
  const [vigilanteOriginal, setVigilanteOriginal] = useState({ persona: '', id: '' });
  const [turnoDataOriginal, setTurnoDataOriginal] = useState(null);

  useEffect(() => {
    cargarInformacionTurnoExistente();
  }, [turnoId]);

  const cargarInformacionTurnoExistente = async () => {
    try {
      setLoading(true);
      const turnoData = await obtenerTurnoPorId(cuadranteId, turnoId, currentService);
      if (!turnoData) {
        setError('Turno no encontrado');
        return;
      }
      setTurnoDataOriginal(turnoData);
      setInicioTurno(turnoData.inicioTurno);
      setFinTurno(turnoData.finTurno);
      setArcos(turnoData.arcos);
      setManejoExplosivos(turnoData.manejoExplosivos);
      setPeligrosidad(turnoData.peligrosidad);
      setConArma(turnoData.conArma);
      setObservaciones(turnoData.observaciones);
      setFechaSeleccionada(turnoData.fecha);
      setTurnoAsignado(turnoData.turno || '');
      let vigilanteId = turnoData.vigilanteId || '';
      if (!vigilanteId && turnoData.vigilante) {
        const vigilante = await obtenerVigilantePorCodigoPersona(turnoData.vigilante, currentService);
        if (vigilante?.id) vigilanteId = vigilante.id;
      }
      setVigilanteOriginal({ persona: turnoData.vigilante || '', id: vigilanteId });
    } catch (error) {
      setError('Error al cargar información del turno existente');
    } finally {
      setLoading(false);
    }
  };

  const handleSubmitTurno = async (event) => {
    event.preventDefault();
    setError('');
    setExito(false);
    try {
      const numPersonas = parseRequierePersonas(observaciones);
      const numPersonasAnterior = parseRequierePersonas(turnoDataOriginal?.observaciones || '');

      await actualizarTurno(cuadranteId, turnoId, {
        inicioTurno,
        finTurno,
        arcos,
        manejoExplosivos,
        peligrosidad,
        conArma,
        observaciones,
        fecha: fechaSeleccionada,
        vigilante: vigilanteOriginal.persona,
        vigilanteId: vigilanteOriginal.id,
        turno: turnoAsignado,
      }, currentService);

      if (numPersonas > 1 && numPersonas > numPersonasAnterior) {
        const extras = numPersonas - Math.max(1, numPersonasAnterior);
        const turnoDataExtra = {
          fecha: fechaSeleccionada,
          inicioTurno,
          finTurno,
          arcos,
          manejoExplosivos,
          peligrosidad,
          conArma,
          observaciones,
          turno: turnoAsignado,
          servicioId: turnoDataOriginal?.servicioId,
          sinAsignar: true,
          fechaCreacion: new Date().toISOString()
        };
        for (let i = 0; i < extras; i++) {
          await agregarTurno(cuadranteId, turnoDataExtra, currentService);
        }
      }

      setExito(true);
      setTimeout(() => {
        if (typeof onUpdateComplete === 'function') onUpdateComplete();
        if (typeof onClose === 'function') onClose();
      }, 1200);
    } catch (error) {
      setError('Error al actualizar turno');
    }
  };

  if (loading) {
    return (
      <div className="create-tramo-container">
        <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
          <CircularProgress />
          <Typography ml={2}>Cargando datos...</Typography>
        </Box>
      </div>
    );
  }

  return (
    <div className="create-tramo-container">
      <Typography variant="h5" component="h2" gutterBottom>
        Actualizar Turno
      </Typography>
      {error && (
        <Alert severity="error" style={{ marginBottom: '16px' }}>{error}</Alert>
      )}
      {exito && (
        <Alert severity="success" style={{ marginBottom: '16px' }}>Turno actualizado correctamente</Alert>
      )}
      <form onSubmit={handleSubmitTurno}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <div style={{ paddingLeft: 8, paddingRight: 8 }}>
              <label className="form-label">
                Fecha:
                <input type="date" value={fechaSeleccionada} onChange={e => setFechaSeleccionada(e.target.value)} className="form-input" required style={{ paddingLeft: 12, paddingRight: 12 }} />
              </label>
            </div>
          </Grid>
          <Grid item xs={12} md={6}>
            <div style={{ paddingLeft: 8, paddingRight: 8 }}>
              <label className="form-label">
                Hora de inicio:
                <input type="time" value={inicioTurno} onChange={e => setInicioTurno(e.target.value)} className="form-input" required style={{ paddingLeft: 12, paddingRight: 12 }} />
              </label>
            </div>
          </Grid>
          <Grid item xs={12} md={6}>
            <div style={{ paddingLeft: 8, paddingRight: 8 }}>
              <label className="form-label">
                Hora de fin:
                <input type="time" value={finTurno} onChange={e => setFinTurno(e.target.value)} className="form-input" required style={{ paddingLeft: 12, paddingRight: 12 }} />
              </label>
            </div>
          </Grid>
          <Grid item xs={12}>
            <div style={{ paddingLeft: 8, paddingRight: 8 }}>
              <Typography variant="subtitle1" gutterBottom>
                Características del turno:
              </Typography>
              <FormGroup row>
                <FormControlLabel control={<Checkbox checked={arcos} onChange={() => setArcos(!arcos)} />} label="Arcos" />
                <FormControlLabel control={<Checkbox checked={manejoExplosivos} onChange={() => setManejoExplosivos(!manejoExplosivos)} />} label="Manejo de Explosivos" />
                <FormControlLabel control={<Checkbox checked={peligrosidad} onChange={() => setPeligrosidad(!peligrosidad)} />} label="Peligrosidad" />
                <FormControlLabel control={<Checkbox checked={conArma} onChange={() => setConArma(!conArma)} />} label="Con Arma" />
              </FormGroup>
            </div>
          </Grid>
          <Grid item xs={12}>
            <div style={{ paddingLeft: 8, paddingRight: 8 }}>
              <label className="form-label">
                Observaciones (ej: requiere 2 personas):
                <textarea value={observaciones} onChange={e => setObservaciones(e.target.value)} className="form-textarea" rows={3} placeholder="Escribe 'requiere X personas' para crear X filas en el cuadrante" style={{ paddingLeft: 12, paddingRight: 12 }} />
              </label>
            </div>
          </Grid>
          <Grid item xs={12}>
            <div className="button-container">
              <Button type="button" variant="outlined" color="secondary" onClick={onClose}>
                Cancelar
              </Button>
              <Button type="submit" variant="contained" color="primary">
                Actualizar Turno
              </Button>
            </div>
          </Grid>
        </Grid>
      </form>
    </div>
  );
};

export default ActualizarTurno;